import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { UserService } from '../services/user.service';
import { EncriptDecriptService } from '../services/encriptdecript';
import { Router } from '@angular/router';

@Component({
  selector: 'app-test-candidate',
  templateUrl: './test-candidate.component.html',
  styleUrls: ['./test-candidate.component.scss']
})
export class TestCandidateComponent implements OnInit {
  testCandidateForm: FormGroup;
  public emailRegex = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$';
  // should allow space , ifen , underscore and numaric , alpha
  private underscore_hiphen_space_alpha_num_only = '[a-zA-Z _.]*';
  categoryList = [];
  errorMessage: any = '';
  userCredentials: {};
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  dropdownList: Array<any> = [];
  selectedItems: Array<any> = [];
  dropdownSettings: any = {};
  constructor(private fb: FormBuilder,
    private userService: UserService,
    private encriptDecript: EncriptDecriptService,
    private router: Router) { }

  ngOnInit() {
    this.createTestCandidateForm();
    this.getCategoryList();
    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'key',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',      
      allowSearchFilter: false       
    };
    // itemsShowLimit: 3,
    // limitSelection: 3
  }

  createTestCandidateForm() {
    this.testCandidateForm = this.fb.group({
      firstName: ['', [Validators.required,
      Validators.pattern(this.underscore_hiphen_space_alpha_num_only),
      Validators.minLength(3)]],
      lastName: ['', [Validators.required,
      Validators.pattern(this.underscore_hiphen_space_alpha_num_only)]],
      emailId: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      course: [this.selectedItems,[Validators.required]]

    });
    this.testCandidateForm.valueChanges.subscribe(value => {
      // console.log(value);
    })
  }

  getCategoryList() {
    this.userService.categoryListForTestCandidate('').subscribe(response => {
      if (response) {
        for (let obj of response) {
          var data = {
            "value": obj[0],
            "key": obj[1]
          }
          this.categoryList.push(data);
        }
        this.dropdownList = this.categoryList;
      }
    });
  }

  sumbitTestCandidate() {
    if (this.testCandidateForm.valid) {
      const categoryId = this.course.value.map(elm => elm.value);
      var payload = {
        'firstName': this.firstName.value,
        'lastName': this.lastName.value,
        'emailId': this.emailId.value
      }
      this.errorMessage = '';
      this.userService.saveTestUser(payload, categoryId)
        .subscribe(response => {
          if (response.status.success !== 'Success' && response.status.success == 'Fail') {
            this.errorMessage = response.status.message;
          } else {
            this.userCredentials = {
              "emailId": response.data.emailId,
              "passwordHash": response.data.passwordHash
            }
            this.goToUserDashBoard();
          }
        }, (error) => {
          this.errorMessage = error.message;
        });
    }
  }

  goToUserDashBoard() {
    this.userService.login(this.userCredentials).subscribe(
      response => {
        if (response.status.success !== 'Success' && response.status.success == 'Fail') {
          this.errorMessage = response.status.message;
        } else {
          this.encriptDecript.setKyeToLocalStorage('token', response.token);
          // this.encriptDecriptService.getKeyLocalStorage('token')=response.token;
          localStorage.isLogin = true;
          this.encriptDecript.setToLocalStorage('userObject', response.data);
          var userObj: any = this.encriptDecript.getLocalStorage('userObject');
          const userDetail = JSON.parse(userObj);
          const role = userDetail.roles[0];
          const logo = 'null';
          localStorage.setItem('logo', logo);
          if (response.data.isAdmin === true) {
            this.encriptDecript.setToLocalStorage('dashboardURL', '/admin/dashboard');
            this.router.navigate(['/admin/dashboard']);
          } else {
            let routeNavigation: any;
            this.encriptDecript.setToLocalStorage('dashboardURL', '/admin/dashboard');
            for (let i = 0; i < role.applicationRolePermission.length; i++) {
              if (role.applicationRolePermission[i].isUpdate ||
                role.applicationRolePermission[i].isWrite ||
                role.applicationRolePermission[i].isDelete) {
                return routeNavigation = this.router.navigate(['/admin/dashboard']);
              } else {
                this.encriptDecript.setToLocalStorage('userName', response.data.firstName);
                this.encriptDecript.setToLocalStorage('email', response.data.emailId);
                this.encriptDecript.setToLocalStorage('dashboardURL', '/user/dashboard/browse');
                routeNavigation = this.router.navigate(['/user/dashboard/browse']);
              }
            }
            return routeNavigation;
          }
        }
        this.errorMessage = '';
      })
  }


  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  onSelectAll(items: any) {
    // console.log('onSelectAll', items);
  }
 

  get firstName(): AbstractControl {
    return this.testCandidateForm.get('firstName');
  }
  get lastName(): AbstractControl {
    return this.testCandidateForm.get('lastName');
  }
  get emailId(): AbstractControl {
    return this.testCandidateForm.get('emailId');
  }
  get course(): AbstractControl {
    return this.testCandidateForm.get('course');
  }


}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/test-candidate/test-candidate.component.ts